<template>
  <v-card class="log">
    <v-subheader class="log__subheader">
      <v-icon medium color="primary" class="mr-2">info</v-icon>
      <span class="ml-2 body-2">{{date}} [{{category}}] [level {{level}}] [{{event}}] {{message}}</span>
    </v-subheader>
  </v-card>
</template>

<script>
export default {
  name: "Log",
  props: [
    "date",
    "category",
    "level",
    "event",
    "message"
  ]
}
</script>

<style scoped>
.log {
  border: 1px solid #78909C;

}

.log__subheader {
  min-height: 48px;
  height: auto !important;
}
</style>
